import { render, staticRenderFns } from "./EngineAttachments.vue?vue&type=template&id=22aa4e2b"
import script from "./EngineAttachments.vue?vue&type=script&lang=js"
export * from "./EngineAttachments.vue?vue&type=script&lang=js"
import style0 from "./EngineAttachments.vue?vue&type=style&index=0&id=22aa4e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports